export const Link = {
  baseStyle: {
    fontFamily: 'body',
    _hover: {
      textDecoration: 'none',
    },
  },
};
